<template>      
  <div id="landing">
    <rtx-spinner v-if="feed.length < 1" class="page-spinner"/>
    <div v-else>
      <site-header/>
      <!-- If a single entry is requested via route param "eid", show the full-entry view -->
      <div v-if="isSingleEntry">
        <entry :entry="feed[0]" tileType="single"/>
      </div>
      <!-- Otherwise, show the multi-tile feed -->
      <div v-else>
        <tiles :feed="feed"/>
      </div>
      <!-- Use the proper component name "SiteFooter" -->
      <site-footer ref="footerElement"/>
    </div>
  </div>
</template>

<script>
import { getTrendingFeed } from '../../backend/site.js';
import { getFullEntry } from '../../backend/site.js';
import { getTopicEntries } from '../../backend/site.js';
import Tiles from "@/components/site/Tiles.vue";
import Entry from "@/components/site/Entry.vue";
import SiteHeader from "@/components/common/Header.vue";
import SiteFooter from "@/components/common/Footer.vue";
import RTXSpinner from "@/components/common/RTXSpinner.vue";

export default {
  name: 'Landing',
  components: {
    tiles: Tiles,
    entry: Entry,
    SiteHeader,
    SiteFooter,
    RTXSpinner
  },
  data () {
    return {
      selectedPageId: 'pagashi',
      viewportSize: 0,
      feed: []
    }
  },
  computed: {
    isSingleEntry() {
      return !!this.$route.params.eid;
    },
    currentEntry() {
      return this.isSingleEntry ? this.feed[0] : null;
    },
    pageTitle() {
      if (this.currentEntry) {
        let title = this.currentEntry.entry.content.title;
        return title + ' - Commentoid';
      } else {
        return 'Commentoid - Trending 🔥';
      }
    },
    pageUrl() {
      return window.location.href;
    },
    pageDescription() {
      if (this.currentEntry) {
        return this.currentEntry.entry.content.description;
      } else {
        return 'Explore popular and trending comments.';
      }
    },
    ogDescription() {
      if (this.currentEntry) {
        return this.currentEntry.entry.content.description;
      } else {
        return 'Explore trending and popular comments on hot topics brewing on the web. Discover past favorites updated daily.';            
      }
    },
    ogImage() {
      if (this.currentEntry) {
        return this.currentEntry.entry.thumbnails.high.url;
      } else {
        return 'https://www.commentoid.com/static/commentoid-og-image.png';
      }
    }
  },
  metaInfo () {
    return {
      title: this.pageTitle,
      titleTemplate: '%s',
      meta: [ 
        { name: 'title', content: this.pageTitle },
        { name: 'description', content: this.pageDescription },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: this.pageUrl },
        { property: 'og:title', content: this.pageTitle },
        { property: 'og:description', content: this.ogDescription },
        { property: 'og:image', content: this.ogImage },
        { property: 'twitter:card', content: 'summary_large_image' },
        { property: 'twitter:url', content: this.pageUrl },
        { property: 'twitter:title', content: this.pageTitle },
        { property: 'twitter:description', content: this.ogDescription },
        { property: 'twitter:image', content: this.ogImage }
      ]
    }
  },
  mounted() {
    this.updateViewportSize(); 
    window.addEventListener('resize', this.updateViewportSize);
    // Check route parameters: if "eid" is present, fetch that single entry;
    // if "topic" is provided, fetch topic entries; otherwise, get the trending feed.
    let urlId = this.$route.params.eid;
    let topic = this.$route.params.topic;
    if (urlId) {
      this.getEntry(urlId); 
    } else if (topic) {
      this.getTopic(topic);
    } else {
      this.getFeed();
    }
  },
  created() {
    window.addEventListener('resize', this.updateViewportSize);
  },
  destroyed() {
    window.removeEventListener('resize', this.updateViewportSize);
  },
  methods: {
    updateViewportSize () {
      this.viewportSize = window.innerWidth;
    },
    pageClicked(payload) {
      this.selectedPageId = payload.itemId;
    },
    getFeed () {
      getTrendingFeed({})
      .then(result => {
        this.feed = result.data.value;
      })
      .catch(error => {
        console.error('Failed to submit request.', error);
      });
    },
    getTopic (topic) {
      getTopicEntries({ topic })
      .then(result => {
        this.feed = result.data.value;
      })
      .catch(error => {
        console.error('Failed to submit request.', error);
      });
    },
    getEntry (urlId) {
      getFullEntry({ urlId: urlId })
      .then(result => {
        this.feed = [ result.data.value ];
      })
      .catch(error => {
        console.error('Failed to submit request.', error);
      });
    }
  }
}
</script>

<style scoped>
#landing { 
  margin: auto;
  max-width: 64rem;
  min-height: 100vh;
}
.page-spinner {
  position: fixed;
  top: 50vh;
  left: 50%;   
  transform: translate(-50%, -50%);
}
/* Additional styles retained from your original file */
.main-content {
  min-height: 80vh;
}
.tabs {
  display: flex;
  font-size: 1rem;
  margin: 1rem 3rem;
  justify-content: flex-end;
}
.tabs-grid-item {
  display: grid;
  grid-template-columns: auto 2rem;
  height: 1rem;
  align-items: center;
  margin-left: 0.5rem;
  cursor: pointer;
}
.tab-item-text {
  padding-right: 0.04rem;
  color: grey;
  font-size: 0.96rem;
}
.tab-item-selected {
  color: black;
  border-bottom: 1px solid;
}
.tab-icon-image {
  opacity: 0.5;
}
.dashx-focus-maroon {
  color: #BA0D61;
  font-weight: 500;
}
.login-button-small-img {
  width: 32px;
  cursor: pointer;
}
a, u {
  text-decoration: none;
}
@media screen and (max-width: 70rem) {
  .header-left {
    padding-left: 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/site/Landing.vue